import React from "react";
import { backendUrl } from "../../constants";

const AttachmentList = ({
    planPreview,
    primaryColor,
    commonWhiteColor,
    commonColor,
    interRegular,
    isAdvisor
}) => {
    return (
        <>
            {(planPreview?.attachment || []).map((file, index) => (
                <a
                    href={backendUrl + file}
                    target="_blank"
                    rel="noreferrer"
                    key={index}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 8,
                        borderRadius: 12,
                        backgroundColor: commonWhiteColor,
                        border: "1px solid #EAECF0",
                        padding: 12,
                        gap: 8,
                        cursor: "pointer",
                        width: "100%",
                        color: "#0a0a0a",
                        maxWidth: "100%"
                    }}
                >
                    {/* File Icon */}
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 0.75H27C27.1212 0.75 27.2375 0.798088 27.3232 0.883789L38.1162 11.6768C38.2019 11.7625 38.25 11.8788 38.25 12V36C38.25 37.7949 36.7949 39.25 35 39.25H11C9.20507 39.25 7.75 37.7949 7.75 36V4C7.75 2.20507 9.20508 0.75 11 0.75Z" stroke="#D0D5DD" stroke-width="1.5" />
                        <path d="M27 0.5V8C27 10.2091 28.7909 12 31 12H38.5" stroke="#D0D5DD" strokeWidth="1.5" />
                        <path d="M1 20C1 18.8954 1.89543 18 3 18H25C26.1046 18 27 18.8954 27 20V32C27 33.1046 26.1046 34 25 34H3C1.89543 34 1 33.1046 1 32V20Z" fill={isAdvisor ? "#494DA2" : "#2978b5"} />
                        {/* <path d="M1 20C1 18.8954 1.89543 18 3 18H25C26.1046 18 27 18.8954 27 20V32C27 33.1046 26.1046 34 25 34H3C1.89543 34 1 33.1046 1 32V20Z" fill={!planPreview?.company?.isDefault ? "#2978b5" : "#494DA2"} /> */}
                        <path d="M4.8323 30V22.7273H7.70162C8.25323 22.7273 8.72316 22.8326 9.11142 23.0433C9.49967 23.2517 9.7956 23.5417 9.9992 23.9134C10.2052 24.2827 10.3082 24.7088 10.3082 25.1918C10.3082 25.6747 10.204 26.1009 9.99565 26.4702C9.78732 26.8395 9.48547 27.1271 9.09011 27.3331C8.69712 27.5391 8.22127 27.642 7.66255 27.642H5.83372V26.4098H7.41397C7.7099 26.4098 7.95375 26.3589 8.14551 26.2571C8.33964 26.1529 8.48405 26.0097 8.57875 25.8274C8.67581 25.6428 8.72434 25.4309 8.72434 25.1918C8.72434 24.9503 8.67581 24.7396 8.57875 24.5597C8.48405 24.3774 8.33964 24.2365 8.14551 24.1371C7.95138 24.0353 7.70517 23.9844 7.40687 23.9844H6.36994V30H4.8323ZM13.885 30H11.3069V22.7273H13.9063C14.6379 22.7273 15.2676 22.8729 15.7955 23.1641C16.3235 23.4529 16.7295 23.8684 17.0136 24.4105C17.3 24.9527 17.4433 25.6013 17.4433 26.3565C17.4433 27.1141 17.3 27.7652 17.0136 28.3097C16.7295 28.8542 16.3211 29.272 15.7884 29.5632C15.2581 29.8544 14.6237 30 13.885 30ZM12.8445 28.6825H13.8211C14.2757 28.6825 14.658 28.602 14.9681 28.4411C15.2806 28.2777 15.515 28.0256 15.6713 27.6847C15.8299 27.3414 15.9092 26.8987 15.9092 26.3565C15.9092 25.8191 15.8299 25.38 15.6713 25.0391C15.515 24.6982 15.2818 24.4472 14.9717 24.2862C14.6615 24.1252 14.2792 24.0447 13.8247 24.0447H12.8445V28.6825ZM18.5823 30V22.7273H23.3976V23.995H20.1199V25.728H23.078V26.9957H20.1199V30H18.5823Z" fill="white" />
                    </svg>


                    {/* File Name */}
                    <span
                        style={{
                            flex: 1,
                            fontSize: 14,
                            fontFamily: interRegular,
                            lineHeight: "20px",
                            wordBreak: "break-all",
                            color: '#0a0a0a'
                        }}
                    >
                        {file}
                    </span>
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z" fill="#f1f7fb" fill-opacity="0.1" />
                        <path d="M10.0168 18.5942C9.90328 18.4145 9.84654 18.3246 9.81477 18.186C9.79091 18.0819 9.79091 17.9178 9.81477 17.8137C9.84654 17.6751 9.90328 17.5852 10.0168 17.4055C10.9546 15.9205 13.7462 12.1665 18.0003 12.1665C22.2545 12.1665 25.0461 15.9205 25.9839 17.4055C26.0974 17.5852 26.1541 17.6751 26.1859 17.8137C26.2098 17.9178 26.2098 18.0819 26.1859 18.186C26.1541 18.3246 26.0974 18.4145 25.9839 18.5942C25.0461 20.0791 22.2545 23.8332 18.0003 23.8332C13.7462 23.8332 10.9546 20.0791 10.0168 18.5942Z" stroke={isAdvisor ? "#494DA2" : "#2978b5"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18.0003 20.4998C19.381 20.4998 20.5003 19.3805 20.5003 17.9998C20.5003 16.6191 19.381 15.4998 18.0003 15.4998C16.6196 15.4998 15.5003 16.6191 15.5003 17.9998C15.5003 19.3805 16.6196 20.4998 18.0003 20.4998Z" stroke={isAdvisor ? "#494DA2" : "#2978b5"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>

                </a>
            ))}
        </>
    );
};

export default AttachmentList;
